import { FALSE } from 'sass'
import {
  GET_TEAMS,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAIL,
  ADD_TEAMS,
  ADD_TEAMS_SUCCESS,
  ADD_TEAMS_FAIL,
  UPDATE_TEAMS,
  UPDATE_TEAMS_SUCCESS,
  UPDATE_TEAMS_FAIL,
  DELETE_TEAMS,
  DELETE_TEAMS_SUCCESS,
  DELETE_TEAMS_FAIL,
  SET_TEAM_FIELD_ERRORS,
} from './actionTypes'

// Get Teams
export const getTeams = (check = false,id=null) => ({
  type: GET_TEAMS,
  payload: { check,id }
})

export const getTeamsSuccess = (teams) => ({
  type: GET_TEAMS_SUCCESS,
  payload: teams,
})

export const getTeamsFail = (error) => ({
  type: GET_TEAMS_FAIL,
  payload: error,
})

// Add Team
export const addTeam = (team, check = false,onClose) => ({
  type: ADD_TEAMS,
  payload: { team, check: check ? true : false,onClose },
})

export const addTeamSuccess = (team) => ({
  type: ADD_TEAMS_SUCCESS,
  payload: team,
})

export const addTeamFail = (error) => ({
  type: ADD_TEAMS_FAIL,
  payload: error,
})

// Update Team
export const updateTeam = (team, check = false,onClose) => ({
  type: UPDATE_TEAMS,
  payload: { team, check,onClose },
})

export const updateTeamSuccess = (team) => ({
  type: UPDATE_TEAMS_SUCCESS,
  payload: team,
})

export const updateTeamFail = (error) => ({
  type: UPDATE_TEAMS_FAIL,
  payload: error,
})

// Delete Team
export const deleteTeam = (id, check = false) => ({
  type: DELETE_TEAMS,
  payload: { id, check },
})

export const deleteTeamSuccess = (id) => ({
  type: DELETE_TEAMS_SUCCESS,
  payload: id,
})

export const deleteTeamFail = (error) => ({
  type: DELETE_TEAMS_FAIL,
  payload: error,
})

// Set Field Errors
export const setTeamFieldErrors = (errors) => ({
  type: SET_TEAM_FIELD_ERRORS,
  payload: errors,
})
